module.exports = __webpack_public_path__ + "img/charm_8.1e1b9852.png";